import { Routes } from '@angular/router';
import { ProductsListComponent } from '@products/products-list/products-list.component';
import { ProductsDetailComponent } from '@products/products-detail/products-detail.component';

export const ProductsRoutes: Routes = [
  {
    path: '',
    component: ProductsListComponent,
    data: { titleKey: 'routes.products' },
  },
  {
    path: ':id',
    component: ProductsDetailComponent,
    data: { titleKey: 'routes.productDetails' },
  },
];
